<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.jornada"
        ref="DataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="create(item)"
                authorize="create-ambulatorio-jornada"
                color="primary"
                small
                title="Visualizar"
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'cadastroCidadao.nome', searchable: true, sortable: true},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cadastroCidadao.dataNascimento', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cadastroCidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cadastroCidadao.cns', searchable: true, sortable: true},
            {key: 'actions', label: 'Ações', name: 'actions', class: 'col-min'},
        ],
    }),
    methods: {
        create(item) {
            if (!item.cnsValido) {
                this.showWarningNotification('Profissional com CNS inválido. Agendamento não permitido.')
            } else {
                this.$router.push({name: 'ambulatorio-jornada-create', params: {id: item.id}})
            }
        },
    },
    mixins: [repository],
}
</script>